import React from 'react'
import {Doughnut} from 'react-chartjs-2'
import type {LanguageDistribution} from './_requests'

interface Props {
  data: LanguageDistribution[]
  periodLabel: string
}

const COLORS = ['#a3a242', '#d7383c', '#F6C6C6', '#de3b40', '#efb034', '#d4d395']

export const LanguageDistributionChart: React.FC<Props> = ({data, periodLabel}) => {
  const chartItems = data.filter((d) => d.minutes > 0 && d.percentage > 0)
  const hasData = chartItems.length > 0

  const chartData = {
    labels: chartItems.map((d) => d.language),
    datasets: [
      {
        data: chartItems.map((d) => d.percentage),
        backgroundColor: COLORS.slice(0, chartItems.length),
        borderWidth: 2,
        borderColor: '#fff',
        hoverOffset: 4,
      },
    ],
  }

  const options: any = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '65%',
    plugins: {
      legend: {display: false},
      tooltip: {
        callbacks: {
          label: (ctx: any) => {
            const item = chartItems[ctx.dataIndex]
            return `${item.language}: ${item.percentage}% (${item.minutes.toLocaleString()} mins)`
          },
        },
      },
    },
  }

  return (
    <div className='cp-chart-card'>
      <h3 className='cp-chart-card__title'>Language Distribution</h3>
      <p className='cp-chart-card__subtitle'>{periodLabel}</p>
      {hasData ? (
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          <div style={{position: 'relative', width: 192, height: 192, marginBottom: 24}}>
            <Doughnut data={chartData} options={options} />
          </div>
          <div className='cp-donut-legend'>
            {chartItems.map((d, i) => (
              <div key={d.language} className='cp-donut-legend__item'>
                <span
                  className='cp-donut-legend__swatch'
                  style={{backgroundColor: COLORS[i] || COLORS[COLORS.length - 1]}}
                />
                <span>{d.language}</span>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className='cp-empty cp-chart-empty'>
          No language distribution data for the selected period
        </div>
      )}
    </div>
  )
}
